import { Outlet } from "react-router-dom";

import { FilterProviderTypeProvider } from "./filter-provider-type/filter-provider-type.context";
import './provider-type.scss';

export function ProviderType() {
  return (
    <div id="ShellProviderType" className="provider-type">
       <FilterProviderTypeProvider>
        <Outlet />
      </FilterProviderTypeProvider>
    </div>
  );
}

export default ProviderType;
